"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NexusFaceAttributes = exports.FaceElementData = void 0;
var FaceElementData;
(function (FaceElementData) {
    FaceElementData[FaceElementData["INDEX"] = 0] = "INDEX";
    FaceElementData[FaceElementData["NORMAL"] = 1] = "NORMAL";
    FaceElementData[FaceElementData["COLOR"] = 2] = "COLOR";
    FaceElementData[FaceElementData["TEXTURE_COORDINATES"] = 3] = "TEXTURE_COORDINATES";
    FaceElementData[FaceElementData["DATA"] = 4] = "DATA";
})(FaceElementData = exports.FaceElementData || (exports.FaceElementData = {}));
class NexusFaceAttributes {
    constructor(index, normal, color, texCoord, data) {
        this.index = index;
        this.normal = normal;
        this.color = color;
        this.texCoord = texCoord;
        this.data = data;
        this.size = 6;
    }
}
exports.NexusFaceAttributes = NexusFaceAttributes;
